import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { Stepper, Step } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Form, FormElement } from "@progress/kendo-react-form";
import {
  SimpleLoading,
  PromotionalFooterPure,
  DialogSystemGLPure,
  ButtonHLPure,
} from "../../pures";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Cancel } from "../../../assets/logos/icons";
import "./configuration-plan-renovation.css";
const CustomStepItem = (props) => {
  return (
    <Step {...props}>
      <span className="k-step-indicator">
        <img src={props.icon} alt="" className="item-step-icon"></img>
      </span>
      <span className="k-step-label k-step-text label-stepper">
        {props.itemElement}
      </span>
    </Step>
  );
};

const ConfigurationPlanRenovationView = (props) => {
  let StepComponent = props.stepMetadata[props.selectedStep].component;
  const { t, i18n } = useTranslation();
  props.changeTranslates(props.steps, t, i18n);

  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    // width: "auto",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  const containerTableAndHeadersStyles = {
    marginTop: "20px",
    maxWidth: "100%",
  };

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            style={containerTableAndHeadersStyles}
          >
            <div className="table-wapprer">
              <h3 className="SignatureRequestDetailView-table-title-h3">
                {t("configurationPlanRenovationView.renovationTitle")}
              </h3>
            </div>
            <Grid
              container
              className="configuration-plan"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              <Container col={12}>
                <div className="steps center stepper-movil">
                  <Stepper
                    value={props.selectedStep}
                    items={props.steps}
                    item={CustomStepItem}
                  />
                </div>
              </Container>
              <Form
                allowSubmit={true}
                valid={true}
                onSubmit={props.onSubmit}
                render={(formRenderProps) => (
                  <Container className="form renewal-form">
                    <Container
                      className="user-register-form-renewal"
                      spacing={4}
                    >
                      <FormElement className="center form-element-size-plan">
                        <div>
                          <div style={{ maxWidth: "100%" }}>
                            <div className="title-form-step">
                              <h3 className="user-register-title">
                                {props.steps[props.selectedStep].itemElement}.
                              </h3>
                            </div>
                            {/* <h4 className="user-register-steps">
                              {t("configurationPlanRenovationView.steps")}{" "}
                              {props.selectedStep + 1}{" "}
                              {t("configurationPlanRenovationView.of")}{" "}
                              {props.steps.length}
                            </h4> */}
                            {/* {props.selectedStep === 0 ? <div className="configuration-plan-renovation-pdf-download">Detalle de nuestros paquetes aqui.</div> : null} */}
                          </div>
                          <StepComponent
                            style={{ display: "flex" }}
                            {...props}
                            validator={props.validator}
                            regex={props.regex}
                            validateInput={props.validateInput}
                            fromPage={props.fromPage}
                          />
                        </div>
                        <div
                          className="buttons mb-3 buttons-renewal"
                          spacing={4}
                        >
                          {props.contractCreated ? (
                            <ButtonHLPure
                              primary
                              nameBtn={t("button.continue")}
                              onClickBtn={() =>
                                props.isLastStep
                                  ? props.goToApp()
                                  : props.onSubmit()}
                            />
                          ) : (
                            <>
                              <ButtonHLPure
                                nameBtn={props.steps[props.selectedStep].labelreturn}
                                onClickBtn={(e) => props.onBackStep(e)}
                              />
                              <ButtonHLPure
                                primary
                                nameBtn={props.a3Direct ? t("button.continue") : props.steps[props.selectedStep].itemSup}
                                onClickBtn={(event) =>
                                  !(
                                    props.selectedStep ===
                                    Number(
                                      process.env.REACT_APP_PLAN_RENEWAL_STEP
                                    ) && props.card
                                  )
                                    ? props.onSubmit(event)
                                    : null}
                              />
                            </>
                          )}
                        </div>
                      </FormElement>
                      <PromotionalFooterPure />
                    </Container>
                  </Container>
                )}
              />
            </Grid>
          </Container>

          {props.showNotificationAlert && (
            <Dialog
              style={{ textAlign: "center" }}
              title={"govo.digital"}
              onClose={props.toggleDialog}
              width={256}
              height={280}
            >
              <img style={{ marginTop: "25px", width: "55px", height: "55px" }} alt="" src={Cancel} />
              <p style={{ margin: "25px", textAlign: "center" }}>
                {props.message}
              </p>
            </Dialog>
          )}
        </Container>
      )}
      {/* <NotificationPure
        notification={props.showNotification}
        type={props.notification.type}
        style={props.notification.style}
        onClose={props.onCloseOpenModal}
        message={props.message}
      /> */}
      <DialogSystemGLPure
        {...props}
        message={props.message}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleWarningRequesting={props.toggleWarningRequesting}
      />
    </div>
  );
};

export { ConfigurationPlanRenovationView as default };
